/* eslint-disable no-case-declarations */
import classnames from 'classnames';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { FILTER_PARAMS,filterSearchKey } from 'components/zpFilter/filterUtils';
import { buildCmpSubpagesUrls, buildCppSubpageUrl, openInCurrentTab} from 'utils';
import { CMP_SUBPAGES, CPP_SUBPAGES } from 'utils/constant';
import { gtm } from 'utils/gtm';

const propTypes = {
  variant: PropTypes.oneOf(['cmp', 'cpp']),
  title: PropTypes.string.isRequired,
  jobTitle: PropTypes.string,
  companyLink: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
      toPass: PropTypes.object,
      linkTitle: PropTypes.string,
    })
  ).isRequired,
  btnText: PropTypes.string,
  noBottomSpacing: PropTypes.bool,
  src: PropTypes.string,
  containerClassName: PropTypes.string,
};
const defaultProps = {
  variant: 'cmp',
  jobTitle: '',
  companyLink: '',
  btnText: 'Find A Job Near Me',
  src: '',
  noBottomSpacing: false,
  noTopSpacing: false,
  containerClassName: '',
};

export default function CMPInlineCallout({
  variant,
  companyLink,
  title,
  jobTitle,
  list = [],
  btnText,
  noBottomSpacing,
  noTopSpacing,
  src,
  TitleTag = 'p',
  titleClasses = '',
  containerClassName,
}) {
  if (!list?.length) return null;

  const onLinkClick = (toPass) => () => {
    let filterValues = {};
    switch (variant) {
      case 'cpp':
        filterValues = {
          [FILTER_PARAMS.JOB_TITLE]: [toPass?.value?.name],
        };
        localStorage.setItem(filterSearchKey, JSON.stringify(filterValues));
        break;
      default:
        filterValues = {
          [FILTER_PARAMS.JOB_TITLE]: [jobTitle],
        };
        localStorage.setItem(filterSearchKey, JSON.stringify(filterValues));
    }
  };

  const onBtnClick = () => {
    let url;

    switch (variant) {
      case 'cpp':
        url = src?.length
          ? buildCppSubpageUrl(companyLink, null, CPP_SUBPAGES.JOBS) + src
          : buildCppSubpageUrl(companyLink, null, CPP_SUBPAGES.JOBS);
        break;
      case 'cmp':
      default:
        url = src?.length
          ? buildCmpSubpagesUrls(jobTitle, null, CMP_SUBPAGES.JOBS) + src
          : buildCmpSubpagesUrls(jobTitle, null, CMP_SUBPAGES.JOBS);
    }

    gtm.logJobCalloutClick(src);

    openInCurrentTab(url);
  };

  return (
    <div
      id="jobs-callout"
      className={classnames('', containerClassName, {
        'z-mt-36': !noTopSpacing,
        'z-mb-36 z-mb-lg-48': !noBottomSpacing,
      })}
    >
      <TitleTag className={classnames('open-sans-large-black-bold', titleClasses)}>{title}</TitleTag>
      <ol className="z-pl-30 z-mb-24">
        {list.map(({ text, link, toPass = {}, linkTitle = '' }) => (
          <li key={`callout-employer-${text}`} className="z-mb-8">
            {link ? (
              <a
                className="alink"
                href={link + src}
                title={linkTitle}
                onClick={onLinkClick(toPass)}
                onContextMenu={onLinkClick(toPass)}
              >
                {text}
              </a>
            ) : (
              text
            )}
          </li>
        ))}
      </ol>
      <ZpButton
        theme="super-primary"
        size="big"
        type="button"
        className="text-capitalize max-w-responsive"
        onClick={onBtnClick}
        overflowHidden
      >
        {btnText}
      </ZpButton>
    </div>
  );
}

CMPInlineCallout.propTypes = propTypes;
CMPInlineCallout.defaultProps = defaultProps;
